import React, { FC, memo } from "react";
// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
// styles
import { ContainerXp2, HalfCardDetails, MastHeadLogo, SubTitles } from "../styles";
// types
import { BottomSheetData } from "@super-ui/components/m2c-swiggy-one-halfcard/types";
// utils
import { isEmpty } from "@swiggy-private/js-utils";
// constants
import { M2C_HALFCARD_TEST_IDS, XP2_MASTHEAD_PROPS } from "@super-ui/components/m2c-swiggy-one-halfcard/constants";

const VariantXpSecond: FC<BottomSheetData> = ({ title, subtitles, logoCtx, isOneLite }) => {
    return (
        <ContainerXp2>
            {!isEmpty(logoCtx?.logo) && (
                <MastHeadLogo data-testid={M2C_HALFCARD_TEST_IDS.LOGO_V2}>
                    <Image cloudinaryId={logoCtx.logo} {...XP2_MASTHEAD_PROPS(isOneLite)} />
                </MastHeadLogo>
            )}
            <HalfCardDetails>
                {!isEmpty(title) && (
                    <Text
                        data-testid={M2C_HALFCARD_TEST_IDS.TITLE_V2}
                        variant="V2.heading1.neutral.black"
                        color="text_Highest_Emphasis"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                )}

                {!isEmpty(subtitles) && typeof subtitles !== "string" && (
                    <div data-testid={M2C_HALFCARD_TEST_IDS.SUBTITLE_V2}>
                        {subtitles?.map((subTitle: string) => (
                            <SubTitles
                                key={subTitle}
                                variant="V2.body2.neutral.regular"
                                color="primary"
                                dangerouslySetInnerHTML={{ __html: subTitle }}
                            />
                        ))}
                    </div>
                )}
            </HalfCardDetails>
        </ContainerXp2>
    );
};

export default memo(VariantXpSecond);
